import blur from '../../images/blur.png'

const Blur = ({className}) => {
  return (
    <section className={className}>
        <img src={blur} alt='/' />
    </section>
  )
}

export default Blur;